import React from "react";
import {
  RiAddCircleLine,
  RiCheckboxCircleLine,
  RiDeleteBinLine,
  RiPencilLine,
} from "@remixicon/react";

import { useTheme } from "@mui/material/styles";
import { DialogActionsT } from "../../../types/ScheduleForm";

export default function DeliveriesComboItemIcon({
  action,
  isSelected,
}: {
  action: DialogActionsT;
  isSelected: boolean;
}) {
  const theme = useTheme();

  if (isSelected && action.startsWith("ADD")) {
    return <RiCheckboxCircleLine color={theme.palette.success.light} />;
  }

  if (isSelected && action === "CHANGE") {
    return <RiPencilLine color={theme.palette.success.light} />;
  }

  if (isSelected && action === "REMOVE") {
    return <RiDeleteBinLine color={theme.palette.error.light} />;
  }

  return <RiAddCircleLine />;
}
